export default "__VITE_ASSET__4bf5cf34__"